import { call, take, put, fork, cancel, select } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'

import * as actionTypesNotifications from '../notifications/action-types'
import * as actionTypesAuth from '../auth/action-types'
// import * as actionTypesError from '../errors/action-types'
import { getUser } from '../auth/selectors'

const EVENTS = {
  NEW_NOTIFICATION: 'NEW_NOTIFICATION',
}

const createWebSocket = ({ userId, companyId }) => {
  const websocketEndpoint =
    process.env.REACT_APP_WS_ENDPOINT || window.REACT_APP_WS_ENDPOINT
  const url =
    websocketEndpoint +
    `/subscribe?id=channel-users,channel-user-${userId},channel-user-company-${companyId}`
  return new WebSocket(url)
}

const createSocketChannel = socket => {
  return eventChannel(emit => {
    const eventHandler = event => {
      emit(event)
    }

    const errorHandler = errorEvent => {
      emit(new Error(errorEvent))
    }

    socket.onmessage = event => {
      eventHandler(event.data)
    }

    socket.onerror = error => {
      errorHandler(error)
    }

    const unsubscribe = () => {
      socket.close()
    }

    return unsubscribe
  })
}

function* initGetEventsSaga(userInfo) {
  const socket = yield call(createWebSocket, userInfo)
  const socketChannel = yield call(createSocketChannel, socket)
  while (true) {
    try {
      const payload = yield take(socketChannel)

      switch (payload) {
        case EVENTS.NEW_NOTIFICATION:
          yield put({
            type: actionTypesNotifications.FETCH,
          })
          break
        default:
          break
      }
    } catch (error) {
      // NOTE: la gestión de errores se ha cancelado en este caso a petición de Dokify
      //       para evitar la redirección constante a la página de error, ya que
      //       los sockets no están operativos
      // yield put({ type: actionTypesError.ERROR, payload: { error } })
    }
  }
}

export default function* rootSaga() {
  while (true) {
    yield take(actionTypesAuth.SET_USER)
    yield put({ type: actionTypesNotifications.FETCH })
    const user = yield select(getUser)
    const task = yield fork(initGetEventsSaga, {
      userId: user.id,
      companyId: user.company_id,
    })
    yield take(actionTypesAuth.LOGOUT)
    yield cancel(task)
  }
}
